export const INITIAL = {
	MODAL: {
		content: '',
		data: {}
	},
	VALUES: {
		name: '',
		description: '',
		climate: '',
		period: '',
	},
	LIST: {
		columns: {
			name: 'Campanha',
			description: 'Descrição',
		},
		rows: [],
	},
}